import { Page } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import { useNavigate } from 'react-router-dom';
import { RenderHeadersAction } from '../../Panel';
import '../skeleton/skeleton.css'
import { mappingSkeleton } from '../skeleton/skeleton';
import JSONValueMapping from './JSONValueMapping/JSONValueMapping';
import XMLValueMapping from './XMLValueMapping/XMLValueMapping';
import { useTranslation } from 'react-i18next';
interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

const ValueMapping = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    const [loader, setLoader] = useState<boolean>(true);
    const navigate = useNavigate();
    useEffect(() => {
        const timeout = setTimeout(() => setLoader(false), 500);
        return () => {
            clearTimeout(timeout)
        }
    }, [])

    return <>
        {loader ? mappingSkeleton() : <Page
            title={t('Value Mapping')}
            subtitle={t('Map attributes values for better product visibility on Amazon. Select values matching to corresponding Amazon attribute values.')}
            backAction={
                {
                    content: t("Value Mapping"),
                    onAction: () => {
                        navigate("../config/templateSettings/new");
                    },
                }
            }
            primaryAction={
                <RenderHeadersAction {...props} disable_headers={true} />
            }>
            {
                props?.location?.state?.type == 'json' ? <JSONValueMapping {...props} /> : <XMLValueMapping {...props} />
            }
        </Page >}
    </>;
}

export default DI(ValueMapping);